import makeStyles from '@material-ui/core/styles/makeStyles';
import { TableCell, lighten, darken, alpha } from '@material-ui/core';
import clsx from 'clsx';
import { i18n } from '@lingui/core';

import { SIZED_CELL_CLASS, INNER_CELL_VALUE_CLASS } from '../DataTableConstants';

const useStyles = makeStyles((theme) => ({
    root: {
        border: 'none',
    },

    innerBorder: {
        marginRight: theme.spacing(1),
        borderStyle: 'solid',
        borderWidth: '0 0 1px 0',
        borderColor:
            theme.palette.type === 'light'
                ? lighten(alpha(theme.palette.divider, 1), 0.88)
                : darken(alpha(theme.palette.divider, 1), 0.68),

        '&:last': {
            marginRight: 0,
        },

        '&.hidden': {
            border: 'none',
            margin: 0,
        },
    },
}));

export default function GroupHeader(props) {
    const {
        group: { title, width, hidden },
    } = props;
    const classes = useStyles();

    return (
        <TableCell
            variant="head"
            size="small"
            align="center"
            component="div"
            style={{ width: `${width}px` }}
            className={clsx(classes.root, SIZED_CELL_CLASS, 'disable-padding')}
        >
            <div className={clsx(SIZED_CELL_CLASS, classes.innerBorder, { hidden })}>
                <div className={clsx(SIZED_CELL_CLASS, INNER_CELL_VALUE_CLASS)}>{title ? i18n._(title) : ''}</div>
            </div>
        </TableCell>
    );
}
